/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppBusinessProfileDataSchema = z.object({
	about: z.string().nullable(),
	address: z.string().nullable(),
	email: z.string().nullable(),
	websites: z.array(z.string()).nullable(),
	vertical: z.string().nullable(),
	profilePictureUrl: z.string().nullable(),
})

export type WhatsAppBusinessProfileDataSchema = z.infer<typeof whatsAppBusinessProfileDataSchema>
